(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // class StickyHeader extends HTMLElement {
  //   constructor() {
  //     super();
  //   }

  //   connectedCallback() {
  //     this.header = document.querySelector('.section-header');
  //     this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  //     this.headerBounds = {};

  //     this.setHeaderHeight();

  //     // window.matchMedia('(max-width: 1050px)').addEventListener('change', this.setHeaderHeight.bind(this));

  //     // window.matchMedia('(max-width: 542px)').addEventListener('change', this.setHeaderHeight.bind(this));

  //     this.trottleResize = throttle(() => this.setHeaderHeight(), 500);
  //     window.addEventListener('resize', this.trottleResize.bind(this));

  //     if (this.headerIsAlwaysSticky) {
  //       this.header.classList.add('shopify-section-header-sticky');
  //     };

  //     this.currentScrollTop = 0;
  //     this.preventReveal = false;
  //     this.predictiveSearch = this.querySelector('predictive-search');

  //     this.onScrollHandler = this.onScroll.bind(this);
  //     this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  //     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.addEventListener('scroll', this.onScrollHandler, false);

  //     this.createObserver();
  //   }

  //   setHeaderHeight() {
  //       let isMobileMQ = window.matchMedia("(max-width: 1050px)");
  //       let transparentHeader = this.querySelector('.header--homepage-transparent');
  //       let headerHeight = this.header.offsetHeight;
  //       if(transparentHeader){
  //           headerHeight = transparentHeader.offsetHeight + 1;
  //       }
      
  //     if(isMobileMQ.matches){
  //       let padding = 40;
  //       let searchBar = this.querySelector('.search-non-modal');
  //       let searchBarHeight = searchBar.getBoundingClientRect().height;
  //       headerHeight -= (searchBarHeight + padding);
  //     }
  //     document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  //     let announcementBar = document.querySelector('.announcement-bar-section');
  //     let announcementBarHeight = 0;
  //     if(announcementBar){
  //       announcementBarHeight = announcementBar.getBoundingClientRect().height;
  //       document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
  //     }

  //   }
    

  //   disconnectedCallback() {
  //     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  //     window.removeEventListener('scroll', this.onScrollHandler);
  //   }

  //   createObserver() {
  //     let observer = new IntersectionObserver((entries, observer) => {
  //       this.headerBounds = entries[0].intersectionRect;
  //       observer.disconnect();
  //     });

  //     let transparentHeader = this.querySelector('.header--homepage-transparent');
  //     if(transparentHeader){
  //       observer.observe(transparentHeader);
  //     }
  //     else{
  //         observer.observe(this.header);
  //     }
  //   }

  //   onScroll() {
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  //     if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  //     if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');


  //       let announcementBar = document.querySelector('.announcement-bar-section');
  //       let announcementBarHeight = 0;
  //       if(announcementBar){
  //         announcementBarHeight = announcementBar.getBoundingClientRect().height;
  //         document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
  //       }

  //       var utility_bar = document.querySelector('.utility-bar');
  //       if (utility_bar.classList.contains('sticky')) {
  //           this.header.style.top = `${announcementBarHeight}px`;
  //           announcementBar.style.position = 'sticky';
  //           announcementBar.style.top = '0';
  //       }

  //       if (this.preventHide) return;
  //       requestAnimationFrame(this.hide.bind(this));
  //     } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  //       this.header.classList.add('scrolled-past-header');
  //       if (!this.preventReveal) {
  //         requestAnimationFrame(this.reveal.bind(this));
  //       } else {
  //         window.clearTimeout(this.isScrolling);

  //         this.isScrolling = setTimeout(() => {
  //           this.preventReveal = false;
  //         }, 66);

  //         requestAnimationFrame(this.hide.bind(this));
  //       }
  //     } else if (scrollTop <= this.headerBounds.top) {
  //       this.header.classList.remove('scrolled-past-header');
  //       requestAnimationFrame(this.reset.bind(this));
  //     }

  //     this.currentScrollTop = scrollTop;
  //   }

  //   hide() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  //     this.closeMenuDisclosure();
  //     this.closeSearchModal();
  //   }

  //   reveal() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.add('shopify-section-header-sticky', 'animate');
  //     this.header.classList.remove('shopify-section-header-hidden');
  //   }

  //   reset() {
  //     if (this.headerIsAlwaysSticky) return;
  //     this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  //   }

  //   closeMenuDisclosure() {
  //     this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  //     this.disclosures.forEach(disclosure => disclosure.close());
  //   }

  //   closeSearchModal() {
  //     this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  //     if(this.searchModal){
  //       this.searchModal.close(false);
  //     }
  //   }
  // }

  // customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
